import { Alert } from 'ui';
import { IconBling } from 'ui/Icons';

interface AlertMessageProps {
  isAuthenticated: boolean;
}

const AlertMessage: React.FC<AlertMessageProps> = ({ isAuthenticated }) => {
  return isAuthenticated ? (
    <Alert title="View All Tickets In Your Wallet" icon={<IconBling />}>
      All your purchased tickets are in your wallet, organized by event.
    </Alert>
  ) : (
    <Alert title="Download the Givebacks App or Sign In" icon={<IconBling />}>
      Download the Givebacks app and register using the email associated with your ticket purchase
      for easy access to your tickets, and to view all your purchased tickets in your wallet,
      organized by event.
    </Alert>
  );
};

export default AlertMessage;
